export const difference = <T>(array1: T[], array2: T[]): T[] => {
  const set2 = new Set(array2)
  return array1.filter((item) => !set2.has(item))
}
